import type { JSX } from 'react';

export default function AboutMe(): JSX.Element {
  return (
    <main className="mx-auto max-w-3xl px-4 py-12">
      <div className="rounded-md bg-white p-6 shadow-sm ring-1 ring-neutral-200">
        <h1 className="text-2xl font-bold text-neutral-900">
          Welcome to Shaping Colours – Where Art Transcends Boundaries!
        </h1>

        <p className="mt-4 text-neutral-700">
          At Shaping Colours, we believe that art is the embodiment of the extraordinary within the ordinary. It is
          the realm where the impossible becomes possible, revealing vistas hidden from common sight, and
          transforming dreams into tangible visions. Art is the medium through which thoughts take shape, ideas are
          infused with vibrant hues, and an entire universe emerges from the void. In this process, life finds its
          voice amidst the silence of emptiness, providing new meanings to our very existence.
        </p>

        <p className="mt-4 text-neutral-700">
          Our mission is to ignite fresh perspectives, to cultivate an appreciation for art, and to pay homage to the
          luminaries who&apos;ve paved the artistic path. Shaping Colours is more than an initiative; it&apos;s a
          movement to awaken creativity, to nurture the designer, the artist, and the creator residing within you.
        </p>

        <h2 className="mt-6 font-semibold text-neutral-900">
          Let us introduce you to the driving force behind Shaping Colours – The Artist Herself:
        </h2>

        <p className="mt-4 text-neutral-700">
          Meet Suhasini Kalaghatgi, a soul captivated by the allure of nature&apos;s beauty and the elegance of human
          form. Her heart resonates with the age-old mastery of artistic legends, and she draws inspiration from the
          profound simplicity that keeps their masterpieces eternally young, no matter how many times they&apos;re
          beheld. Suhasini captures the essence of her subjects through a lens of realism, often weaving her
          impressions from the rich tapestry of the masters&apos; creations.
        </p>

        <h2 className="mt-6 font-semibold text-neutral-900">Academic Qualifications</h2>
        <ul className="mt-2 list-none text-neutral-700">
          <li>🎨 B.F.A (Painting), Nagpur University, 1983</li>
          <li>🎨 M.F.A (Portrait Painting), Nagpur University, 1985</li>
        </ul>

        <p className="mt-4 text-neutral-700">
          Join us in exploring the world of artistry that transcends time. Let Shaping Colours be your guide to
          discovering uncharted dimensions of your creativity. Whether you&apos;re an accomplished artist, an
          aspiring creator, or someone taking their first steps into the realm of art, we&apos;re here to journey
          alongside you. Together, let&apos;s reimagine the canvas of possibilities and paint stories that resonate
          across eras.
        </p>

        <p className="mt-4 font-semibold text-neutral-900">
          Welcome to Shaping Colours – Where Your Artistic Journey Begins!
        </p>
      </div>
    </main>
  );
}
